import { useSelector } from 'react-redux';
import { Box, Icon } from '@quintoandar-tokko/jopijs';
import PendingCard from '../../DashboardPendings/PendingsCard';
import styles from './performanceCard.module.scss';

export default function PerformanceCardHeader({
  handleClickTableIcon = null,
  extraActions = null,
  className = '',
  children,
  ...rest
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const showTableIcon = handleClickTableIcon && !edition.active;

  return (
    <Box className={`${styles.title} ${className}`} {...rest}>
      <PendingCard.Header>{children}</PendingCard.Header>
      {(extraActions || showTableIcon) && (
        <Box className={styles.headerActions}>
          {extraActions}
          {showTableIcon && (
            <Icon
              icon="icon-tabla"
              className={styles.tableIcon}
              onClick={handleClickTableIcon}
            />
          )}
        </Box>
      )}
    </Box>
  );
}
